/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutResponse } from '../../models/put-response';
import { StoreAggregatorInput } from '../../models/store-aggregator-input';

export interface StoresStoreIdAggregatorsPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: StoreAggregatorInput
}

export function storesStoreIdAggregatorsPut(http: HttpClient, rootUrl: string, params: StoresStoreIdAggregatorsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdAggregatorsPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PutResponse>;
    })
  );
}

storesStoreIdAggregatorsPut.PATH = '/stores/{storeId}/aggregators';
